/**
 * Hook for managing spiritual traditions selection
 */

import { useQuery } from "@tanstack/react-query"
import { getSpiritualTraditions } from "../services/user.service"

export function useSpiritualTraditions() {
  const {
    data: traditions = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["spiritual-traditions"],
    queryFn: getSpiritualTraditions,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  return {
    traditions,
    isLoading,
    error,
    refetch,
  }
}
